import React from 'react';
import { Routes, Route } from 'react-router';
import { AssignmentProvider } from '../../context';
import StandardPrinting from './components/StandardPrinting';
import AnswerKey from './components/AnswerKey';
import VocabularyPrinting from './components/VocabularyPrinting';

const MoreActions = () => {
  return (
    <AssignmentProvider>
      <Routes>
        <Route path="/standardPrinting" element={<StandardPrinting />} />
        <Route path="/answerKey" element={<AnswerKey />} />
        <Route path="/vocabularyPrinting" element={<VocabularyPrinting />} />
      </Routes>
    </AssignmentProvider>
  );
};

export default MoreActions;
